import _classCallCheck from "/home/greenhack/tfjs-yolov5-example/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/greenhack/tfjs-yolov5-example/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
import { env } from './environment';
import * as util from './util';
export var Profiler = /*#__PURE__*/function () {
  function Profiler(backendTimer, logger) {
    _classCallCheck(this, Profiler);

    this.backendTimer = backendTimer;
    this.logger = logger;

    if (logger == null) {
      this.logger = new Logger();
    }
  }

  _createClass(Profiler, [{
    key: "profileKernel",
    value: function profileKernel(kernelName, inputs, f) {
      var outputs;

      var holdResultWrapperFn = function holdResultWrapperFn() {
        outputs = f();
      };

      var timer;
      var start = util.now();

      if (this.backendTimer.timerAvailable()) {
        timer = this.backendTimer.time(holdResultWrapperFn);
      } else {
        holdResultWrapperFn();

        var _iterator = _createForOfIteratorHelper(outputs),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var output = _step.value;
            output.dataSync();
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        timer = Promise.resolve({
          kernelMs: util.now() - start
        });
      }

      if (env().getBool('CHECK_COMPUTATION_FOR_ERRORS')) {
        var _loop = function _loop(i) {
          var output = outputs[i]; // Dangling promise here because we don't want to propagate up
          // asynchronicity.

          output.data().then(function (tensorVals) {
            checkComputationForErrors(tensorVals, output.dtype, kernelName);
          });
        };

        for (var i = 0; i < outputs.length; i++) {
          _loop(i);
        }
      }

      var kernelProfile = {
        kernelName: kernelName,
        outputs: outputs,
        inputs: inputs,
        timeMs: timer.then(function (timing) {
          return timing.kernelMs;
        }),
        extraInfo: timer.then(function (timing) {
          return timing.getExtraProfileInfo != null ? timing.getExtraProfileInfo() : '';
        })
      };
      return kernelProfile;
    }
  }, {
    key: "logKernelProfile",
    value: function logKernelProfile(kernelProfile) {
      var _this = this;

      var kernelName = kernelProfile.kernelName,
          outputs = kernelProfile.outputs,
          timeMs = kernelProfile.timeMs,
          inputs = kernelProfile.inputs,
          extraInfo = kernelProfile.extraInfo;
      outputs.forEach(function (result) {
        Promise.all([result.data(), timeMs, extraInfo]).then(function (valueContainer) {
          _this.logger.logKernelProfile(kernelName, result, valueContainer[0], valueContainer[1], inputs, valueContainer[2]);
        });
      });
    }
  }]);

  return Profiler;
}();
export function checkComputationForErrors(vals, dtype, kernelName) {
  if (dtype !== 'float32') {
    // Only floating point computations will generate NaN values
    return false;
  }

  for (var i = 0; i < vals.length; i++) {
    var num = vals[i];

    if (isNaN(num) || !isFinite(num)) {
      // Throwing custom exception so behavior is testable.
      console.warn("Found ".concat(num, " in the result of '").concat(kernelName, "'"));
      return true;
    }
  }

  return false;
}
export var Logger = /*#__PURE__*/function () {
  function Logger() {
    _classCallCheck(this, Logger);
  }

  _createClass(Logger, [{
    key: "logKernelProfile",
    value: function logKernelProfile(name, result, vals, timeMs, inputs, extraInfo) {
      var time = typeof timeMs === 'number' ? util.rightPad("".concat(timeMs, "ms"), 9) : timeMs['error'];
      var paddedName = util.rightPad(name, 25);
      var rank = result.rank;
      var size = result.size;
      var shape = util.rightPad(result.shape.toString(), 14);
      var inputShapesDescription = '';

      for (var _name in inputs) {
        var input = inputs[_name];

        if (input != null) {
          // The input might be a non-tensor (e.g HTMLImageElement), in which case
          // we claim the output shape as input shape.
          var inputShape = input.shape || result.shape;
          var inputRank = inputShape.length;
          inputShapesDescription += "".concat(_name, ": ").concat(inputRank, "D ").concat(inputRank > 0 ? inputShape : '', " ");
        }
      }

      console.log("%c".concat(paddedName, "\t%c").concat(time, "\t%c").concat(rank, "D ").concat(shape, "\t%c").concat(size, "\t%c").concat(inputShapesDescription, "\t%c").concat(extraInfo), 'font-weight:bold', 'color:red', 'color:blue', 'color: orange', 'color: green', 'color: steelblue');
    }
  }]);

  return Logger;
}();